import * as React from 'react';
import {Link} from 'react-router-dom';
import TechSmithHeader from '../../assets/TechSmithHeader.svg';

export default ({linkToRoot, refreshOnLink}: HeaderLogoProps) => {
   let logo;

   if (!linkToRoot) {
      logo = <div className="header-logo-button"><TechSmithHeader/></div>;
   } else if (refreshOnLink) {
      logo = <a href="/" className="header-logo-button"><TechSmithHeader/></a>;
   } else {
      logo = <Link to={'/'} className="header-logo-button"><TechSmithHeader/></Link>;
   }

   return (
      <h1 className="header-logo">
         {logo}
      </h1>
   );
};

interface HeaderLogoProps {
   linkToRoot: boolean;
   refreshOnLink?: boolean;
}
